import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import useQueryParams from "modules/queryParams/hooks/useQueryParams";
import logger from "logging/logger";
import { EDC_SSO_REDIRECT_PATH } from "modules/auth/constants";

export const EDCOAuthCallback = () => {
  const { token } = useQueryParams();
  const history = useHistory();

  useEffect(() => {
    const handleAuth = async () => {
      if (!token) {
        history.push("/signin");
        return;
      }

      try {
        const auth = getAuth();
        await signInWithCustomToken(auth, token as string);

        const returnPath = localStorage.getItem(EDC_SSO_REDIRECT_PATH);
        localStorage.removeItem(EDC_SSO_REDIRECT_PATH);

        if (returnPath) {
          const finalPath = returnPath.endsWith("/register")
            ? `${returnPath}?proceed=true`
            : returnPath;
          history.push(finalPath);
        } else {
          history.push("/my-events");
        }
      } catch (error) {
        logger.error("[EDCOAuthCallback] Error signing in with custom token:", {
          error,
        });
        history.push("/signin");
      }
    };

    handleAuth();
  }, [token, history]);

  return null;
};

export default EDCOAuthCallback;
